import { LeadManagementId } from './container/LeadManagement/enum';

export enum Views {
    LINKS = 'fixnet-customer-links',
    FORM = 'fixnet-address-form',
    CAPTCHA = 'fixnet-captcha',
    RESULT = 'fixnet-availability-result-wrapper',
}

export enum AddressFormId {
    WRAPPER = 'fixnet-availability-form-wrapper',
    CITY = 'fixnet-city-input-wrapper',
    STREET = 'fixnet-street-input-wrapper',
    NUMBER = 'fixnet-street-housenumber-wrapper',
    SUBMIT = 'fixnet-address-form-submit',
    NOT_UNIQUE_CONTAINER = 'fixnet-multiple-address-container',
    SELECT = 'fixnet-multiple-adress-select-wrapper',
    TOOLTIP = 'fixnet-address-form-tooltip',
    LINKS_BUTTON = 'fixnet-existing-customer-button-link',
    FORM_BUTTON = 'fixnet-address-form-button-link',
    ADDRESS_ERROR = 'fixnet-address-error',
    SERVICE_ERROR = 'fixnet-service-error'
}

export enum AvailabilityResultId {
    WRAPPER = 'fixnet-availability-result-wrapper',
    MEDIA_TEXT = 'fixnet-media-text',
    MEDIA_TEXT_BUTTON = 'fixnet-media-text-button',
    ADDRESS_TEXT = 'fixnet-address-text',
    CHANGE_BUTTON = 'fixnet-change-button',
    DELETE_BUTTON = 'fixnet-delete-button',
}

export enum AppId {
    IMAGE_HEADER = 'fixnet-image-header',
    OVERLAY = 'fixnet-lead-management-overlay',
    LOADING = 'fixnet-address-loading-spinner',
    TARIFF_CARD = 'fixnet-tariff-card',
    TARIFF_CARD_FF = 'fixnet-tariff-card-ff',
    ACCORDION = 'fixnet-faq-accordion',
    RELATED_LINKS = 'fixnet-related-links-offers',
    ICON_TEXT_BANNER = 'fixnet-icon-text-banner',
    FF_ACCORDION = 'fixnet-ff-accordion',
    FF_ACCORDION_WRAPPER = 'fixnet-ff-accordion-wrapper'
}

export enum PrimaryCardId {
    WRAPPER = 'fixnet-address-result-primary',
    HEADLINE = 'fixnet-result-primary-headline',
    SUBLINE = 'fixnet-result-primary-subline',
    BUTTON = 'fixnet-result-primary-button',
    FLAGBADGE = 'fixnet-result-primary-flagbadge',
}

export enum SecondaryCardId {
    WRAPPER = 'fixnet-address-result-secondary',
    HEADLINE = 'fixnet-result-secondary-headline',
    SUBLINE = 'fixnet-result-secondary-subline',
    BUTTON = 'fixnet-result-secondary-button',
    FLAGBADGE = 'fixnet-result-secondary-flagbadge',
}

export type HtmlId = AddressFormId | AppId | AvailabilityResultId | LeadManagementId | PrimaryCardId | SecondaryCardId;

export enum NameSpace {
    APP = 'IP/APP',
    LEAD_MANAGEMENT = 'IP/LEAD_MANAGEMENT',
    ADDRESS_VALIDATION = 'IP/ADRESS_VALIDATION'
}

export enum CaptchaEvents {
    VERIFIED = 'mtVerified',
    RENDERED = 'mtRendered',
    REJECTED = 'mtRejected',
}

export enum Cookies {
    QA_CAPTCHA = 'VpCaptchaQaAuthorization',
    FRIENDS_AND_FAMILY = 'vfhvalueffv2',
}

export enum Domains {
    VF = 'https://eweb8.vfd2-testnet.de',
    ZUHAUSEPLUS = 'https://zuhauseplus.vodafone.de',
    ST = 'https://simplicity.wf-de.vodafone.com',
    DEV = 'https://jarvis-internet-phone-k8s-wf-de-develop.wf-de.vodafone.com',
}

export enum Endpoints {
    FRIENDS_AND_FAMILY = '/api/friends-and-family/validate',
    LMS = '/api/ftth',
    JARVIS = '/api/jarvis/internetphone/v1/availabilityCheck',
}

export enum HttpStatus {
    BAD_REQUEST = 400,
    UNAUTHORIZED = 401,
    FORBIDDEN = 403,
    INTERNAL = 500,
}

export enum JarvisSuggestionType {
    DSL = 'DSL',
    CABLE = 'Cable',
    FIBER = 'Fiber',
    GIGACUBE = 'GigaCube',
    PRE_SALES = 'PreSales',
    HOMES_PASSED = 'HomesPassed',
}

export enum TokenState {
    VALID = 'valid',
    INVALID = 'invalid',
    UNKNOWN = 'unknown',
}

export enum QueryNames {
    FRIENDS_AND_FAMILY = 'ffv2',
}

export enum WholebuyAccessSupplierType {
    DTAG = 'DTAG',
    DGW = 'DGW'
}

export enum AccessSupplierType {
    VFDE = 'VFDE',
    OXG = 'OXGG',
    DTAG = 'DTAG',
    DGW = 'DGW'
}

export enum AvailabilityIndicator {
    PRE_SALES = 'GELB_GRAU',
    HOME_PASSED = 'ORANGE'
}

export enum WholebuyAvailabilityIndicatorColor {
    GELB_GRAU = 'WholebuyPhase2_PreSales',
    ORANGE = 'WholebuyPhase2_HomePassed'
};

export enum OXGAvailabilityIndicatorColor {
    GELB_GRAU = 'OXG_VVM',
    ORANGE = 'OXG_NVD',
    CONNECTED = 'OXG_RVM'
};

export enum FiberFootprints {
    OXG = 'OXGG',
}

export enum FiberConnectedIndicator {
    CONNECTED = 'GRUEN'
}

export enum NewAvailabilityIndicator {
    ORANGE_ROT = 'ORANGE_ROT',
    GRUEN_GRAU = 'GRUEN_GRAU',
}
